import { CountryCode, Currency, Locale } from '../types/locale'

export function getLocale(route: string): Locale {
  const lowerCaseRoute = route.toLocaleLowerCase()

  switch (true) {
    case lowerCaseRoute.includes('en-ca'):
      return 'en-CA'
    case lowerCaseRoute.includes('fr-ca'):
      return 'fr-CA'
    default:
      return 'en-US'
  }
}

export const countryToCurrencyMap: Record<CountryCode, Currency> = {
  US: 'USD',
  CA: 'CAD',
}
